import { Checkbox, Select } from 'antd';
import styled from 'styled-components';
import { Dropdown, Flex, Icon, IconText } from 'ui';
import { withEllipsis } from 'ui/styles';

const { Option } = Select;

export const EntitySelect = styled(Select)`
  width: ${p => p.isColumnFilter ? '350px' : '90%'} !important;
  .ant-select-selector {
    height: 32px !important;
  }
  font-size: 16px;
  font-weight: 400;
  .ant-select-selection-item {
    display: none;
  }
  .select-footer { 
    cursor: ${p => p.isNewSearch ? 'default' : 'pointer'} !important;
    &:hover {
      background-color: ${p => p.isNewSearch && 'white'};
    }
  }
`;

export const Title = styled.span`
  font-weight: 400;
  font-size: 16px;
`;

export const TypesDropdown = styled(Dropdown)`
  width: 45%;
  height: 34px;
`;

export const ClearIcon = styled(Icon)`
  cursor: pointer;
  color: ${p => p.theme.colors.theme};
`;

export const CheckBoxContainer = styled.div`
  width: 5%;
  ${p => p.marginRight && 'margin-right: 5px;'}
`;

export const InfoContainer = styled(Flex)`
  width: 95%;
`;

export const ItemTitle = styled.span`
  > .highlight {
    color: ${p => p.theme.colors.theme};
    font-weight: ${p => p.theme.fontWeight.bold};
  }
  font-size: ${p => p.theme.fontSize.normal};
  margin-bottom: 3px;
  font-weight: ${p => p.theme.fontWeight.bolder};
  color: ${p => p.theme.colors.textLight};
  ${withEllipsis};
`;

export const HighlightSpan = styled.span`
  font-size: ${p => p.theme.fontSize.normal};
  > .highlight {
    color: ${p => p.theme.colors.theme};
    font-weight: ${p => p.theme.fontWeight.bold};
  }
`;

export const SingleLineSpan = styled.span`
  font-size: ${p => p.theme.fontSize.normal};
  ${withEllipsis};
`;

export const StyledIconText = styled(IconText)`
  text-transform: uppercase;
  float: right !important;
`;

export const SupportingIcon = styled(Icon)`
  color: ${p => p.theme.colors.iconSecondary};
`;

export const Footer = styled(Option)`
  height: 30px;
`;

export const Remove = styled.span`
  cursor: pointer;
  margin-left: 5px;
  text-decoration: underline;
  color: ${p => p.theme.colors.theme};
  height: 30px;
  margin-bottom: 2px;
`;

export const FooterText = styled.span`
  color: ${p => p.theme.colors.theme};
  text-decoration: ${p => p.isNewSearch ? 'none' : 'underline'};
  text-transform: ${p => p.isNewSearch ? 'uppercase' : 'none'};
  line-height: 30px;
  padding-left: ${p => p.isNewSearch ? '0px' : '5%'};
  font-size: 14px;
  display: flex;
  flex-flow: row nowrap;
  span {
    white-space: pre-wrap;
  }
`;

export const SelectOption = styled(Option)`
`;

export const StyledIcon = styled.span`
  width: 5%;
  margin-right: ${p => p.isColumnFilter && '10px'}
`;

export const StyledCheckbox = styled(Checkbox)`
  font-size: 16px;
`;

export const ShowChildren = styled(StyledCheckbox)`
  margin-left: 10px;
`;
